import React, { useState, useEffect } from "react";
import api from "../../api";
import Select from "react-select";
import { Cropper, RectangleStencil } from "react-advanced-cropper";
import "react-advanced-cropper/dist/style.css";
import Modal from "react-modal";

Modal.setAppElement("#root");

const TeacherManagementPage = () => {
    const [teachers, setTeachers] = useState([]);
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [blocks, setBlocks] = useState([]);

    const [form, setForm] = useState({
        name: "",
        father_name: "",
        mobile: "",
        dob: "",
        gender: "",
        blood: "",
        designation: "",
        department_id: "",
        state_id: "",
        city_id: "",
        block_id: "",
        village: "",
        post_office: "",
        police_station: "",
        locality: "",
        pincode: "",
        qualification: "",
        joining_date: "",
        salary: "",
        employee_type: "",
        employee_group: "",
        photo: null,
    });

    const [msg, setMsg] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null); // for edit mode
    const [departments, setDepartments] = useState([]);

    // Image crop states
    const [image, setImage] = useState(null);
    const [cropper, setCropper] = useState(null);
    const [croppedImg, setCroppedImg] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
    const schoolId = localStorage.getItem("school_id");

    const addURL = `/teachers/add`;
    const updateURL = `/teachers/update`;
    const deleteURL = `/teachers/delete`;
    const listURL = `/teachers/list`;

    // fetch departments from API
    const fetchDepartments = async () => {
        try {
            const res = await api.get(`/departments/list?school_id=${schoolId}`);
            console.log("API response:", res.data);  // 👈 check this
            const data = res.data;
            if (data?.status && Array.isArray(data.data)) {
                setDepartments(data.data);
            } else {
                setDepartments([]);
            }
        } catch (err) {
            console.error("Error fetching departments:", err);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchDepartments();
    }, []);

    // Fetch teachers
    const fetchTeachers = async () => {
        try {
            const res = await api.get(`${listURL}?school_id=${schoolId}`);
            setTeachers(res.data?.data || []);
        } catch (err) {
            console.error("Error fetching teachers", err);
        }
    };

    useEffect(() => {
        fetchTeachers();
    }, []);

    // Fetch states
    useEffect(() => {
        fetch("https://dgps.co.in/api/get-states")
            .then((res) => res.json())
            .then((data) => setStates(data.data || []))
            .catch((error) => console.error("Error fetching states:", error));
    }, []);

    // Fetch cities
    useEffect(() => {
        if (form.state_id) {
            fetch(`https://dgps.co.in/api/get-cities/${form.state_id}`)
                .then((res) => res.json())
                .then((data) => setDistricts(data.data || []))
                .catch((error) => console.error("Error fetching districts:", error));
        } else {
            setDistricts([]);
            setForm((prev) => ({ ...prev, city_id: "" }));
        }
    }, [form.state_id]);

    // Fetch blocks
    useEffect(() => {
        if (form.city_id) {
            fetch(`https://dgps.co.in/api/get-blocks/${form.city_id}`)
                .then((res) => res.json())
                .then((data) => setBlocks(data.data || []))
                .catch((error) => console.error("Error fetching blocks:", error));
        } else {
            setBlocks([]);
            setForm((prev) => ({ ...prev, block_id: "" }));
        }
    }, [form.city_id]);

    // File select → open modal
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
                setModalOpen(true);
            };
            reader.readAsDataURL(file);
        }
    };

    // Crop & Save
    const doCrop = () => {
        if (cropper) {
            const canvas = cropper.getCanvas();
            if (canvas) {
                canvas.toBlob((blob) => {
                    if (blob) {
                        const file = new File([blob], "teacher.jpg", { type: "image/jpeg" });
                        setForm((prev) => ({ ...prev, photo: file }));
                        setCroppedImg(URL.createObjectURL(blob));
                        setModalOpen(false);
                    }
                }, "image/jpeg");
            }
        }
    };

    const handleChange = (name, value, type = "text") => {
        let newValue = value;

        if (type === "text") {

            // 🔥 DO NOT sanitize these fields
            if (name === "blood" || name === "gender") {
                newValue = value;
            }
            else if (name === "designation" || name === "qualification") {
                newValue = value.replace(/[^A-Za-z.\-\s]/g, "").toUpperCase();
            }
            else {
                newValue = value.replace(/[^A-Za-z\s]/g, "").toUpperCase();
            }

        } else if (type === "number") {
            newValue = value.replace(/[^0-9]/g, "");
        }

        setForm(prev => ({ ...prev, [name]: newValue }));
    };


    // helper: convert value to "Title Case" with spaces
    const formatLabel = (value) => {
        if (!value) return "";
        return value
            .replace(/_/g, " ")
            .replace(/^(babyland|upper)\s*/i, "")
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMsg(null);

        if (!form.name.trim()) {
            setMsg({ type: "error", text: "Name is required." });
            return;
        }
        if (!form.mobile || !/^\d{10}$/.test(form.mobile)) {
            setMsg({ type: "error", text: "Valid 10-digit Mobile number is required." });
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();
            Object.keys(form).forEach((key) => {
                if (form[key] !== null && form[key] !== "") {
                    formData.append(key, form[key]);
                }
            });
            if (editingId) {
                formData.append("id", editingId);
            }

            const url = editingId ? updateURL : addURL;
            const res = await api.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (res.data?.status) {
                setMsg({ type: "success", text: res.data.message });
                setForm({
                    name: "",
                    father_name: "",
                    mobile: "",
                    dob: "",
                    gender: "",
                    blood: "",
                    designation: "",
                    department_id: "",
                    state_id: "",
                    city_id: "",
                    block_id: "",
                    village: "",
                    post_office: "",
                    police_station: "",
                    locality: "",
                    pincode: "",
                    qualification: "",
                    joining_date: "",
                    salary: "",
                    photo: null,
                });
                setEditingId(null);
                setCroppedImg(null);
                fetchTeachers();
            } else {
                setMsg({ type: "error", text: res.data.message });
            }
        } catch (err) {
            setMsg({ type: "error", text: err.response?.data?.message || "Network error" });
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (teacher) => {
        setForm({
            name: teacher.name || "",
            father_name: teacher.father_name || "",
            mobile: teacher.mobile || "",
            dob: teacher.dob || "",
            gender: teacher.gender || "",
            blood: teacher.blood || "",
            designation: teacher.designation || "",
            department_id: teacher.department_id || "",
            state_id: teacher.state_id || "",
            city_id: teacher.city_id || "",
            block_id: teacher.block_id || "",
            village: teacher.village || "",
            post_office: teacher.post_office || "",
            police_station: teacher.police_station || "",
            locality: teacher.locality || "",
            pincode: teacher.pincode || "",
            qualification: teacher.qualification || "",
            joining_date: teacher.joining_date || "",
            salary: teacher.salary || "",
            employee_type: teacher.employee_type || "",
            employee_group: teacher.employee_group || "",
            photo: null,
        });
        setEditingId(teacher.id);
        setCroppedImg(teacher.photo ? `https://dgps.co.in/${teacher.photo}` : null);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this teacher?")) return;

        try {
            const formData = new FormData();
            formData.append("id", id);

            const res = await api.post(deleteURL, formData);
            if (res.data?.status) {
                setMsg({ type: "success", text: res.data.message });
                fetchTeachers();
            } else {
                setMsg({ type: "error", text: res.data.message });
            }
        } catch (err) {
            setMsg({ type: "error", text: err.response?.data?.message || "Network error" });
        }
    };

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = tableCSS;
        document.head.appendChild(style);
    }, []);

    return (
        <div style={{ display: "flex", minHeight: "100vh" }}>
            <div style={{ flex: 1, backgroundColor: "#f4f6f8" }}>

                <main style={{ padding: "30px", maxWidth: "1200px", margin: "auto", marginTop: "0px" }}>
                    <section style={cardStyle}>
                        <h2 style={titleStyle}>{editingId ? "✏️ Edit Teacher" : "➕ Add Teacher"}</h2>

                        {msg && (
                            <div style={{ marginBottom: 12, color: msg.type === "error" ? "#cc0000" : "#166534" }}>
                                {msg.text}
                            </div>
                        )}

                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                            <div style={formGrid}>
                                <FormGroup label="Name">
                                    <input type="text" value={form.name} onChange={(e) => handleChange("name", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Father's Name">
                                    <input type="text" value={form.father_name} onChange={(e) => handleChange("father_name", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Mobile">
                                    <input type="text" value={form.mobile} onChange={(e) => handleChange("mobile", e.target.value, "number")} style={fullWidthInput} maxLength={10} />
                                </FormGroup>
                                <FormGroup label="Date of Birth">
                                    <input
                                        type="date"
                                        value={form.dob}
                                        onChange={(e) => handleChange("dob", e.target.value, "date")}
                                        style={fullWidthInput}
                                    />

                                </FormGroup>
                                <FormGroup label="Gender">
                                    <Select
                                        options={[
                                            { value: "Male", label: "Male" },
                                            { value: "Female", label: "Female" },
                                            { value: "Other", label: "Other" }
                                        ]}
                                        value={
                                            form.gender
                                                ? { value: form.gender, label: form.gender }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleChange("gender", selected ? selected.value : "", "select")
                                        }
                                        placeholder="Select Gender..."
                                        isClearable
                                        isSearchable={false}
                                    />
                                </FormGroup>

                                <FormGroup label="Blood Group">
                                    <Select
                                        options={[
                                            { value: "A+", label: "A+" },
                                            { value: "A-", label: "A-" },
                                            { value: "B+", label: "B+" },
                                            { value: "B-", label: "B-" },
                                            { value: "AB+", label: "AB+" },
                                            { value: "AB-", label: "AB-" },
                                            { value: "O+", label: "O+" },
                                            { value: "O-", label: "O-" }
                                        ]}
                                        value={
                                            form.blood
                                                ? { value: form.blood, label: form.blood }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleChange("blood", selected?.value || "", "select")
                                        }
                                        placeholder="Select Blood Group..."
                                        isClearable
                                        isSearchable={false}
                                    />
                                </FormGroup>

                                <FormGroup label="Designation">
                                    <input type="text" value={form.designation} onChange={(e) => handleChange("designation", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Department / Role">
                                    <Select
                                        options={departments.map((d) => ({
                                            value: parseInt(d.id),
                                            label: `${d.name} (${d.category}${d.section ? " - " + d.section : ""})`,
                                        }))}
                                        value={
                                            departments.find((d) => parseInt(d.id) === parseInt(form.department_id))
                                                ? {
                                                    value: parseInt(form.department_id),
                                                    label: `${departments.find((d) => parseInt(d.id) === parseInt(form.department_id))?.name} (${departments.find((d) => parseInt(d.id) === parseInt(form.department_id))?.category
                                                        }${departments.find((d) => parseInt(d.id) === parseInt(form.department_id))?.section
                                                            ? " - " + departments.find((d) => parseInt(d.id) === parseInt(form.department_id))?.section
                                                            : ""
                                                        })`,
                                                }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleChange("department_id", selected ? selected.value : "", "select")
                                        }
                                        placeholder="Select department..."
                                        isClearable
                                        isSearchable
                                    />
                                </FormGroup>



                                {/* Address dropdowns */}
                                <FormGroup label="State">
                                    <Select
                                        options={states.map((s) => ({ value: s.id, label: s.name }))}
                                        value={
                                            states.find((s) => s.id === form.state_id)
                                                ? { value: form.state_id, label: states.find((s) => s.id === form.state_id)?.name }
                                                : null
                                        }
                                        onChange={(selected) => handleChange("state_id", selected ? selected.value : "", "select")}
                                        placeholder="Select state..."
                                        isClearable
                                        isSearchable
                                    />
                                </FormGroup>

                                <FormGroup label="District/City">
                                    <Select
                                        options={districts.map((d) => ({ value: d.id, label: d.name }))}
                                        value={
                                            districts.find((d) => d.id === form.city_id)
                                                ? { value: form.city_id, label: districts.find((d) => d.id === form.city_id)?.name }
                                                : null
                                        }
                                        onChange={(selected) => handleChange("city_id", selected ? selected.value : "", "select")}
                                        placeholder="Select district..."
                                        isClearable
                                        isSearchable
                                    />
                                </FormGroup>

                                <FormGroup label="Block">
                                    <Select
                                        options={blocks.map((b) => ({ value: b.id, label: b.name }))}
                                        value={
                                            blocks.find((b) => b.id === form.block_id)
                                                ? { value: form.block_id, label: blocks.find((b) => b.id === form.block_id)?.name }
                                                : null
                                        }
                                        onChange={(selected) => handleChange("block_id", selected ? selected.value : "", "select")}
                                        placeholder="Select block..."
                                        isClearable
                                        isSearchable
                                    />
                                </FormGroup>


                                <FormGroup label="Village">
                                    <input type="text" value={form.village} onChange={(e) => handleChange("village", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Post Office">
                                    <input type="text" value={form.post_office} onChange={(e) => handleChange("post_office", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Police Station">
                                    <input type="text" value={form.police_station} onChange={(e) => handleChange("police_station", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Locality">
                                    <input type="text" value={form.locality} onChange={(e) => handleChange("locality", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Pincode">
                                    <input type="text" value={form.pincode} onChange={(e) => handleChange("pincode", e.target.value, "number")} style={fullWidthInput} maxLength={6} />
                                </FormGroup>
                                <FormGroup label="Qualification">
                                    <input type="text" value={form.qualification} onChange={(e) => handleChange("qualification", e.target.value)} style={fullWidthInput} />
                                </FormGroup>
                                <FormGroup label="Joining Date">
                                    <input
                                        type="date"
                                        value={form.joining_date}
                                        onChange={(e) => handleChange("joining_date", e.target.value, "date")}
                                        style={fullWidthInput}
                                    />

                                </FormGroup>
                                <FormGroup label="Teachers Type">
                                    <Select
                                        options={[
                                            { value: "TEACHING", label: "TEACHING" },
                                            { value: "NON_TEACHING", label: "NON-TEACHING" },

                                        ]}
                                        value={
                                            form.employee_type
                                                ? { value: form.employee_type, label: form.employee_type }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleChange("employee_type", selected?.value || "", "select")
                                        }
                                        placeholder="Select Employee Type..."
                                        isClearable
                                        isSearchable={false}
                                    />
                                </FormGroup>
                                <FormGroup label="Teachers Group">
                                    <Select
                                        options={[
                                            { value: "GROUP_A", label: "GROUP A" },
                                            { value: "GROUP_B", label: "GROUP B" },
                                            { value: "GROUP_C", label: "GROUP C" },
                                            { value: "GROUP_D", label: "GROUP D" },

                                        ]}
                                        value={
                                            form.employee_group
                                                ? { value: form.employee_group, label: form.employee_group }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleChange("employee_group", selected?.value || "", "select")
                                        }
                                        placeholder="Select Employee Group..."
                                        isClearable
                                        isSearchable={false}
                                    />
                                </FormGroup>
                                <FormGroup label="Salary">
                                    <input type="text" value={form.salary} onChange={(e) => handleChange("salary", e.target.value, "number")} style={fullWidthInput} />
                                </FormGroup>

                                <FormGroup label="Photo (JPG only)">
                                    <input type="file" accept="image/jpeg" onChange={handleFileChange} />
                                    {croppedImg && (
                                        <div style={{ marginTop: "10px" }}>
                                            <img src={croppedImg} alt="Cropped Preview" style={{ width: "150px", borderRadius: "6px" }} />
                                        </div>
                                    )}
                                </FormGroup>
                            </div>

                            <div style={{ textAlign: "right", marginTop: "20px" }}>
                                <button type="submit" style={buttonStyle} disabled={loading}>
                                    {loading ? "Saving..." : editingId ? "Update Teacher" : "Save Teacher"}
                                </button>
                            </div>
                        </form>
                    </section>

                    {/* Teacher list */}
                    <section style={cardStyle}>
                        <h2 style={titleStyle}>📋 Teachers</h2>
                        {teachers.length === 0 ? (
                            <p>No teachers found.</p>
                        ) : (
                            <div style={{ overflowX: "auto" }}>
                                <table style={tableStyle}>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Mobile</th>
                                            <th>Designation</th>
                                            <th>Department</th>
                                            <th>Qualification</th>
                                            <th>Joining Date</th>
                                            <th>Salary</th>
                                            <th>Photo</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {teachers.map((t) => (
                                            <tr key={t.id}>
                                                <td>{t.name}</td>
                                                <td>{t.mobile}</td>
                                                <td>{t.designation}</td>
                                                <td>{t.department}</td>
                                                <td>{t.qualification}</td>
                                                <td>{t.joining_date}</td>
                                                <td>₹ {Number(t.salary).toLocaleString()}</td>
                                                <td>
                                                    {t.photo ? (
                                                        <img
                                                            src={`https://dgps.co.in/${t.photo}`}
                                                            alt="teacher"
                                                            style={{ width: "45px", height: "45px", borderRadius: "50%", objectFit: "cover" }}
                                                        />
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => handleEdit(t)}
                                                        style={{ ...buttonStyle, marginRight: "5px", backgroundColor: "#f59e0b" }}
                                                    >
                                                        Edit
                                                    </button>
                                                    {/* <button
                                                        onClick={() => handleDelete(t.id)}
                                                        style={{ ...buttonStyle, backgroundColor: "#dc2626" }}
                                                    >
                                                        Delete
                                                    </button> */}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </section>

                </main>

                {/* Crop Modal */}
                <Modal
                    isOpen={modalOpen}
                    onRequestClose={() => setModalOpen(false)}
                    style={{
                        content: {
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "500px",
                            height: "550px",
                            padding: "20px",
                        },
                    }}
                >
                    <h3 style={{ marginBottom: "10px" }}>Crop Image</h3>
                    {image && (
                        <div style={{ width: "100%", height: "400px" }}>
                            <Cropper
                                src={image}
                                stencilComponent={RectangleStencil}
                                onChange={setCropper}
                                className="cropper"
                            />
                        </div>
                    )}
                    <div style={{ textAlign: "right", marginTop: "15px" }}>
                        <button onClick={() => setModalOpen(false)} style={{ marginRight: "10px", ...buttonStyle }}>
                            Cancel
                        </button>
                        <button onClick={doCrop} style={buttonStyle}>
                            Crop & Save
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

// --- Shared styles ---
const formGrid = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" };

const FormGroup = ({ label, children }) => (
    <div>
        <label style={{ marginBottom: "6px", display: "block", fontWeight: 500, color: "#444" }}>{label}</label>
        {children}
    </div>
);

const fullWidthInput = {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "15px",
    boxSizing: "border-box",
};

const buttonStyle = {
    padding: "8px 18px",
    backgroundColor: "#0077cc",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
};

const cardStyle = { background: "#ffffff", padding: "25px", borderRadius: "12px", marginBottom: "30px" };
const titleStyle = { color: "#0077cc", marginBottom: "25px" };
const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "900px", // scroll trigger on small screens
};

const thTdCommon = {
    padding: "10px 12px",
    textAlign: "left",
    fontSize: "14px",
    borderBottom: "1px solid #ddd",
    whiteSpace: "nowrap",
};

const tableCSS = `
table thead tr {
  background-color: #f1f5f9;
}
table th {
  font-weight: 600;
  color: #374151;
}
table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}
table tbody tr:hover {
  background-color: #f1f5f9;
}
`;

export default TeacherManagementPage;
